__webpack_require__.p = "/customizer/wp-content/themes/qzr-theme/vue-app/dist/";